export class MapSettings {

   public mapSettingsId: number;

   public userId: number;

   public autoZoom: boolean;

   public blackAndWhite: boolean;

   public clusterPoints: boolean;

   public directRoutes: boolean;

   public callerDotIcon: boolean;

   public visitDotIcon: boolean;

   public frequency: boolean;
}
